import { Edit, Trash2 } from "lucide-react";
import Button from "../ui/Button";

import { useAuthStore } from "../../store/authStore";

export default function DomainItem({ domain, onEdit, onDelete }) {
  const { role } = useAuthStore();
  const isAdmin = role === "admin";

  return (
<div key={domain?.id} className="webhook-box">


<a
  href={domain?.domain}
  target="_blank"
  rel="noopener noreferrer"
  className="webhook-url"
>
  {domain?.domain}
</a>

<div className="webhook-actions">
  {isAdmin && (
    <Button variant="plain" onClick={() => onEdit()}>
      <Edit size={14} className="text-slate-600" />
    </Button>
      )}
      {isAdmin && (
  <Button
    variant="plain"
    onClick={() => onDelete()}
  >
    <Trash2 size={14} className="text-danger" />
  </Button>
  )}
</div>
</div>
  );
}

